<template>
    <div class="scroll-panel row-fluid align-items-end col-12 col-lg-6 p-0 m-0" style="transition-delay: 0s">
        <section class="h-100">

            <h4 class="mt-0">My Account</h4>
            <div class="list-view mb-5">
                <ul class="list-group">
                    <li class="list-group-item list-group-item-action" @click="setPage('Password');">Change Password</li>
                </ul>
            </div>

            <h4 class="mt-0">Settings</h4>
            <div class="list-view mb-5">
                <ul class="list-group">
                    <li class="list-group-item list-group-item-action anonymous" @click="setAnonymous">Anonymise Data
                        <i class="fas fa-solid fa-eye-slash float-right anonymous" :class="user.anonymous ? 'active' : 'fa-times-circle'"></i><br>
                        <div class="rounded alert-warning mt-2 mb-0 p-0 px-1 small"><small>Check above to anonymise answers and mood submissions.</small></div>
                    </li>
                </ul>
            </div>

            <h4 class="mt-0">About</h4>
            <div class="list-view mb-5">
                <ul class="list-group">
                    <li class="list-group-item list-group-item-action"><a v-bind:href="this.$company.urlAbout" target="_blank">About {{ this.$companyName }}</a></li>
                    <!--        <li class="list-group-item list-group-item-action"><a v-bind:href="this.$company.urlLegal" target="_blank">Legal</a></li>-->
                    <!--        <li class="list-group-item list-group-item-action"><a v-bind:href="this.$company.urlTerms" target="_blank">Terms & Conditions</a></li>-->
                    <li class="list-group-item list-group-item-action"><a v-bind:href="this.$company.urlPrivacy" target="_blank">Privacy Policy</a></li>
                </ul>
            </div>

            <h4 class="mt-0">Contact Us</h4>
            <div class="list-view mb-5">
                <ul class="list-group">
                    <li class="list-group-item list-group-item-action"><a v-bind:href="this.$company.urlContact" target="_blank">Contact Us</a></li>
                </ul>
            </div>

            <button type="button" class="btn btn-outline-secondary col mt-0 p-2 btn-primary" @click="logout">Logout</button>
            <div class="text-center mt-2"><small>App build version {{ this.$appVersion }}</small></div>
        </section>
    </div>
</template>

<script>

import axios from "axios";

export default {
    name: 'More',
    components: {},
    props: [
        'user',
        'authenticated',
        'parent'
    ],
    data() {
        return {};
    },
    methods: {
        setAnonymous: function () {
            let self = this;
            let anonymous = (self.user.anonymous === 1 ? 0 : 1);
            let formData = new FormData();
            formData.append('user_id', self.user.id);
            formData.append('anonymous', anonymous);
            axios.post("api/user/" + self.user.id + "/update", formData).then(response => {
                if (response.data) {
                    self.user.anonymous = anonymous;
                }
            });
        }
    },
    mounted() {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/More.vue